import React, { Fragment, useRef } from "react";
import css from "./index.module.scss";
import AccordionRow from "./row";

export default function Accordion({
  rows,
  rowClassName = "",
}) {
  return (
    <div className={css.accordion}>
      {rows.map((row) => {
        return <AccordionRow className={rowClassName} key={row.header} row={row}/>;
      })}
    </div>
  );
}
